import React, { useContext, useEffect, useMemo, useState } from "react";
import { responsiveFontSizes } from "@mui/material/styles";
import { ThemeProvider, Backdrop, useTheme } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { InfinitySpin } from "react-loader-spinner";
import { createCustomTheme } from "./utils/createCustomTheme";
import { WhitePaper } from "./Pages";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NetworkChange from "./NetworkChange";
import PageNotFound from "./Pages/PageNotFound";
import StakingUi from "./Pages/Staking/StakingUi";
import { AppContext } from "./utils";
import FarmingUi from "./Pages/Staking/FarmingUi";
import MainHome from "./Pages/LandingPage/MainHome";
import MainExplore from "./Pages/LandingPage/MainExplore";
import "./App.css";
// import ContactUS from "./Pages/LandingPage/ContactUS";

const App = () => {
  const [mode, setMode] = useState("dark");
  const [loader, setLoader] = useState(false);
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const { connect, chainId, account } = useContext(AppContext);

  useEffect(() => {
    if (chainId) {
      if (chainId !== 56) {
        setOpen(true);
      }
    }
  }, [chainId, account]);

  useEffect(() => {
    (async () => {
      if (localStorage.getItem("WEB3_CONNECT_CACHED_PROVIDER")) await connect();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleMode = () => {
    setMode((val) => (val === "light" ? "dark" : "light"));
  };

  const themeClient = useMemo(() => {
    let theme = createCustomTheme(mode);
    theme = responsiveFontSizes(theme);
    return theme;
  }, [mode]);

  return (
    <>
      <ThemeProvider theme={themeClient}>
        <CssBaseline enableColorScheme />
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          limit={3}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme={mode}
        />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <InfinitySpin width="200" color={`${theme.palette.text.primary}`} />
        </Backdrop>
        <Router>
          <NetworkChange open={open} setOpen={setOpen} />
          <Routes>
            <Route
              path="/"
              element={
                <MainHome setLoader={setLoader} toggleMode={toggleMode} />
              }
            />
            <Route path="/whitepaper" element={<WhitePaper />} />
            {/* <Route path="/abc" element={<NewHeroSections />} /> */}

            <Route path="*" element={<PageNotFound />} />
            <Route path="/staking" element={<StakingUi />} />
            <Route path="/farming" element={<FarmingUi />} />
            <Route path="/explore" element={<MainExplore />} />
            {/* <Route path="/contact-us" element={<ContactUS />} /> */}
          </Routes>
        </Router>
      </ThemeProvider>
    </>
  );
};

export default App;
